import React from 'react';

import { Message } from 'src/core/components';

import { getCountryCode } from 'src/utils';
import {
  RNA_OPTIONS,
  SCALE_OPTIONS,
  PURITY_OPTIONS,
  DEFAULT_SENSE_OPTIONS,
  JAPAN_SENSE_OPTIONS,
  JAPAN_COUNTRY_CODE,
  SENSE_OPTIONS
} from './constants';

import messages from './messages';

export const rnaTypeOptions = [{
  label: <Message message={messages.siRna} />,
  value: RNA_OPTIONS.SI_RNA,
}, {
  label: <Message message={messages.stealthRNAi} />,
  value: RNA_OPTIONS.STEALTH_RNAI,
}];

export const overhangOptions = [{
  label: <Message message={messages.overhang} />,
  value: messages.overhang.defaultMessage,
}, {
  label: <Message message={messages.dTdT} />,
  value: 'dTdT',
}];

export const scaleOptions = [{
  label: <Message message={messages.nmole20} />,
  details: { unit: 'nmole', coeficient: 20 },
  value: SCALE_OPTIONS.NMOLE20
}, {
  label: <Message message={messages.nmole80} />,
  details: { unit: 'nmole', coeficient: 80 },
  value: SCALE_OPTIONS.NMOLE80,
}, {
  label: <Message message={messages.umole1} />,
  details: { unit: 'umole', coeficient: 1 },
  value: SCALE_OPTIONS.UMOLE1,
}, {
  label: <Message message={messages.umole1p7} />,
  details: { unit: 'umole', coeficient: 1.7 },
  value: SCALE_OPTIONS.UMOLE1p7,
}];

export const purityOptions = [{
  label: <Message message={messages.desalted} />,
  value: PURITY_OPTIONS.DESALTED,
}];

export const getSenseOptions = () => {
  let options = DEFAULT_SENSE_OPTIONS;

  if (getCountryCode() === JAPAN_COUNTRY_CODE) {
    options = JAPAN_SENSE_OPTIONS;
  }

  return options;
};

export const getScaleOptions = (senseMod) => {
  let options = scaleOptions;

  if (getCountryCode() === JAPAN_COUNTRY_CODE) {
    if (senseMod === SENSE_OPTIONS.BIOTIN) {
      options = [{ ...scaleOptions[0] }];
    } else if (senseMod === SENSE_OPTIONS.FLUORESCIN) {
      options = [{ ...scaleOptions[0] }, { ...scaleOptions[1] }];
    }
  }

  return options;
};
